import React from 'react';
import { InputLabel } from '../../../shared/components/InputLabel';
import { FormGroup } from 'reactstrap';
import { USER_TYPES } from '../../../config/app.config';

export const PermissionsSelect = ({ onChange, value, isPrivate = true }) => {
  return (
    <div className="form__form-group">
      <InputLabel required>Permissions</InputLabel>
      <div className="form__form-group-field">
        <FormGroup>
          <select
            name="type"
            id="type"
            className="form-control form-select"
            value={value}
            onChange={onChange}
          >
            {!isPrivate && (
              <option value={USER_TYPES.IPAD_ONLY}>iPad Only</option>
            )}
            <option value={USER_TYPES.STAFF}>
              {isPrivate ? 'User' : 'User (Web & iPad)'}
            </option>
            <option value={USER_TYPES.ADMIN}>
              {isPrivate ? 'Admin' : 'Admin (Web & iPad)'}
            </option>
          </select>
        </FormGroup>
      </div>
    </div>
  );
};
